import React from 'react';
import Label from '../atoms/Label';

export default ({ label, text, labelregular, textbold, col, red, colorLabel, colorText }) => {
  let colLabel = 'col-md-6'
  let colText = 'col-md-6'
  if( col ){
    colLabel = col.label
    colText = col.text
  }
  let colorLabelState =  red ? 'color-red' : colorLabel ? colorLabel : 'color-text-label' 
  let colorTextState = red ? 'color-red' : colorText ? colorText : 'color-text'
  return(

    <div className='row container-label-with-text'>
      <div className={ colLabel +' text-left' }>
        {
          labelregular ? (
            <Label value={ label } className={ colorLabelState + ' label-kc-s'}/>
          ) : (
            <Label value={ label } className={ colorLabelState + ' label-kc-sb'}/>
          )
        }
      </div>
      <div className={ colText + ' text-left' }>
        {
          textbold ? (
            <Label value={ text } className={ colorTextState + ' label-kc-mb size-text'}/>
          ) : (
            <Label value={ text } className={ colorTextState + ' size-text'}/>
          )
        }
      </div>
    </div>
  )
}